let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Ty6F")).then(() => parcelRequire('3rpr0'));